<template>
  <div :class="[$store.state.layout_style, $store.state.menu_style]">
    <component v-bind:is="layout"></component>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import en from '@/locales/en.json';
// layouts
import appLayout from './layouts/app-layout.vue';
import authLayout from './layouts/auth-layout.vue';

import '@/assets/sass/app.scss';

export default {
  metaInfo: {
    title: 'Home',
    titleTemplate: '%s | OneGC',
  },
  components: {
    app: appLayout,
    auth: authLayout,
  },
  computed: {
    ...mapGetters({
      layout: 'layout',
      locale: 'locale',
    }),
  },
  data() {
    return {};
  },
  watch: {
    locale: {
      handler: function (val) {
        // console.log(this.$route);
        let title = '';
        if (this.$route.meta && this.$route.meta.title) {
          title = this.$route.meta.title;
          if (val == 'en') {
            title = en[title];
          }
        }
        title = title || 'Home';
        document.title = title + ' | OneGC';
      },
    },
  },
  mounted() {
    // let timer = null;
    // document.body.addEventListener('wheel', function () {
    //   document.body.style.setProperty('--x', 0.5);
    //   if (timer) {
    //     window.clearTimeout(timer);
    //     timer = window.setTimeout(() => {
    //       console.log(12323);
    //       document.body.style.setProperty('--x', 0);
    //     }, 1000);
    //   } else {
    //     timer = window.setTimeout(() => {
    //       console.log(321321);
    //       document.body.style.setProperty('--x', 0);
    //     }, 1000);
    //   }
    //   //   console.log(document.querySelector('.el-drawer__wrapper').style.display);
    //   //   const el = document.querySelector('.el-drawer__wrapper');
    //   //   if (el.style.display != 'none') {
    //   //     // e.preventDefault();
    //   //     document.body.style.overflowY = 'hidden';
    //   //   } else {
    //   //     document.body.style.overflowY = 'auto';
    //   //   }
    // });
  },
  methods: {},
};
</script>
